import React from 'react';
import { Button, Dropdown, Menu, Space } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

type RowAction = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  danger?: boolean;
};

type RowActionsProps = {
  onEdit: () => void;
  actions: RowAction[];
};

// A record with nothing behind the menu shows no menu: an empty dropdown
// gives the reader no way to tell it apart from one that failed to load.
const RowActions = ({ onEdit, actions }: RowActionsProps): JSX.Element => (
  <Space size={6}>
    <Button onClick={onEdit} size="small">
      Edit
    </Button>
    {actions.length > 0 && (
      <Dropdown
        trigger={['click']}
        placement="bottomRight"
        overlay={
          <Menu selectable={false}>
            {actions.map(({ label, onClick, disabled, danger }) => (
              <Menu.Item
                key={label}
                onClick={onClick}
                disabled={disabled}
                danger={danger}
              >
                {label}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <Button
          aria-label="More actions"
          aria-haspopup="menu"
          icon={<MoreOutlined />}
          size="small"
        />
      </Dropdown>
    )}
  </Space>
);

export default RowActions;
